// extracted by mini-css-extract-plugin
export default {"container":"InlineClient--container--23c4b1","message":"InlineClient--message--1734d8","gdprMessage":"InlineClient--gdprMessage--3274c2","checkbox":"InlineClient--checkbox--576cd4"};